import { render, staticRenderFns } from "./sba-formatted-obj.vue?vue&type=template&id=1e699e50&"
import script from "./sba-formatted-obj.vue?vue&type=script&lang=js&"
export * from "./sba-formatted-obj.vue?vue&type=script&lang=js&"
import style0 from "./sba-formatted-obj.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports